import React from 'react';
import StatisticsTable from './statistics-table';
import {acceptanceLikelihoodClassification} from 'shared/college-profile/utils';
import AcceptanceLikelihoodExplanation from './acceptance-likelihood/acceptance-likelihood-explanation';
import Icon from 'shared/components/icon';

interface Props {
  college: {
    actEnglish: number[];
    actMath: number[];
    actWriting: number[];
  };
  userInfo: {
    actScore?: {
      scoreEnglish: number;
      scoreMath: number;
      scoreWriting: number;
    };
  };
  showAdmissability?: boolean;
}

interface Row {
  name: string;
  values: React.ReactNode[];
}

const ACTTable = ({college, userInfo, showAdmissability}: Props) => {
  const {actScore} = userInfo;
  const {actEnglish, actMath, actWriting} = college;

  const addDefaultScores = (values: React.ReactNode[]) => {
    values.push(<a href="/portfolio#scores">Enter Score to See Match</a>);
    values.push(<Icon iconType="lock-alt" className="admissability-locked-icon" />);
  };

  const getRows = (): Row[] => {
    const rows: Row[] = [];

    if (actEnglish) {
      const values: React.ReactNode[] = [actEnglish.join('-')];

      if (showAdmissability) {
        if (actScore) {
          values.push(actScore.scoreEnglish);
          values.push(
            acceptanceLikelihoodClassification(actScore.scoreEnglish, actEnglish[0], actEnglish[1])
          );
        } else {
          addDefaultScores(values);
        }
      }

      rows.push({
        name: 'ACT English',
        values,
      });
    }

    if (actMath) {
      const values: React.ReactNode[] = [actMath.join('-')];

      if (showAdmissability) {
        if (actScore) {
          values.push(actScore.scoreMath);
          values.push(
            acceptanceLikelihoodClassification(actScore.scoreMath, actMath[0], actMath[1])
          );
        } else {
          addDefaultScores(values);
        }
      }

      rows.push({
        name: 'ACT Math',
        values,
      });
    }

    if (actWriting) {
      const values: React.ReactNode[] = [actWriting.join('-')];

      if (showAdmissability) {
        if (actScore) {
          values.push(actScore.scoreWriting);
          values.push(
            acceptanceLikelihoodClassification(actScore.scoreWriting, actWriting[0], actWriting[1])
          );
        } else {
          addDefaultScores(values);
        }
      }

      rows.push({
        name: 'ACT Writing',
        values,
      });
    }

    return rows;
  };

  const rows = getRows();

  const cols: React.ReactNode[] = ['Subject', 'Avg. Range'];

  if (showAdmissability) {
    cols.push('Your Score');
    cols.push(
      <span>
        Match
        <AcceptanceLikelihoodExplanation />
      </span>
    );
  }

  const className = showAdmissability ? (actScore ? 'wide-row-headers' : 'with-score-cta') : '';

  return (
    <StatisticsTable className={className} aria-label="ACT Breakdown" header={cols} rows={rows} />
  );
};

export default ACTTable;
